import axios from "axios"
import {apiRequest, ClientService} from "@libs/ClientService"

import {LoggedUserType} from "@backend/types"

type LoginWithTokenTypes = {
    token?: string,
    tempToken?: string
}

class AuthService extends ClientService {
    constructor() {
        super("auth", "auth")
    }

    loginWithToken = ({token, tempToken}: LoginWithTokenTypes) =>
        apiRequest<LoggedUserType>(axios.post(`${this.resourceUrl}/loginWithToken`, {
            token,
            tempToken
        }))

}


export default new AuthService()